/* eslint-disable max-len */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

/**
 * API[研修情報・受講履歴取得: /careerInfoStudentHistory]のペイロードを表すインターフェース。
 * @export
 * @interface
 *
 * @property {string} careerId: 研修ID(必須)
 */
export interface CareerInfoStudentHistoryPayload {
    careerId: string;
}

/**
 * API[研修情報・受講履歴取得: /careerInfoStudentHistory]の正常応答を表すインターフェース。
 * @export
 * @interface
 * @property careerInfoData マスタデータ(研修情報)
 * @property careerClassInfoList マスタデータ(クラス情報)
 * @property topics マスタデータ(章立て情報)
 * @property tasks マスタデータ(課題リスト)
 * @property enquetes マスタデータ(アンケートリスト)
 * @property categories 表示対象分類
 * @property tests テスト履歴リスト
 * @property approvers 承認者リスト
 * @property histories 受講履歴
 * @property appliable 受講申請可否
 */
export interface CareerInfoStudentHistoryResponse {
    careerInfoData: CareerInfoData;
    careerClassInfoList: ClassInfoItem[];
    topics: TopicItem[];
    tasks: TaskListItem[];
    enquetes: EnqueteListItem[];
    tests: TestListItem[];
    appliable: AppliableItem[];
    categories: CategoryItem[];
    approvers: Aprovers;
    histories: CareerHistories;
}

export interface CareerInfoData {
    author: string;
    careerId: string;
    careerReport: string;
    careerSubType: string;
    careerTitle: string;
    careerTypeId: string;
    careerTypeName: string;
    comment: string;
    compulsoryId: string;
    contents: ContentsItem[];
    credit: number;
    enquete: string;
    haveContents: number;
    informationUrl: string;
    inquiry: string;
    managementCode: string;
    materialFiles: MaterialFilesItem[];
    months: string;
    organizer: string;
    outline: string;
    purpose: string;
    reference: string;
    referenceUrl: string;
    studyTime: string;
    target: string;
    textbook: string;
    vendor: string;
    vendorUrl: string;
    version: string;
    webAppFlg: string;
    careerGeneralMst1: string;
    careerGeneralMst2: string;
    careerGeneralMst3: string;
    careerGeneralMst4: string;
    careerGeneralMst5: string;
    careerGeneralMst6: string;
    careerGeneralMst7: string;
    careerGeneralMst8: string;
    careerGeneralMst9: string;
    careerGeneralMst10: string;
    careerGeneralNum1: number;
    careerGeneralNum2: number;
    careerGeneralNum3: number;
    careerGeneralNum4: number;
    careerGeneralNum5: number;
    careerGeneralText1: string;
    careerGeneralText2: string;
    careerGeneralText3: string;
    careerGeneralText4: string;
    jyukoNoClass: string;
    careerImageUrl?: string;
    multiApplyFlag: string;
}
export interface ContentsItem {
    contents: string;
}

export interface MaterialFilesItem {
    fileName: string;
    fileIndex: number;
    fileType: string;
}
export interface ClassInfoItem {
    application: string;
    capacity: string;
    classId: string;
    className: string;
    classRoomNm: string;
    classroom: string;
    cost: string;
    cost1: string;
    placeFileName: string;
    placeUrl: string;
    startToEndDate: string;
    startDate: string;
    endDate: string;
    classroomDefault: string;
    applicationStartline: string;
    applicationDeadline: string;
    placeUrlDefault: string;
    placeFileNameDefault: string;
    careerId: string;
    appliable: Boolean;
}
export interface TopicItem {
    id: string;
    level: string;
    text: string;
    children: TopicItem[];
}

export interface TaskListItem {
    classId: string;
    taskList: TaskItem[];
}
export interface TaskItem {
    expired: true;
    kikan: string;
    reportFileName: string;
    reportMstFlg: string;
    reportMstFlgNum: true;
    resultStatus: string;
    resultStatusNum: true;
    seq: string;
}

export interface EnqueteListItem {
    classId: string;
    enqueteList: EnqueteItem[];
}
export interface EnqueteItem {
    expired: true;
    answerPeriod: string;
    id: string;
    text: string;
    iconClass: string;
    requiredFlg: number;
    enqueteType: string;
}

export interface TestListItem {
    classId: string;
    testList: TestItem[];
}
export interface TestItem {
    displayStyle: number;
    historyCount: number;
    id: string;
    kind: string;
    title: string;
    paperType: string;
    historyList: TestHistoryItem[];
}
export interface TestHistoryItem {
    disableFlg: string;
    endDate: string;
    enqueteUpdDate: string;
    startDate: string;
    thistoryId: string;
    tokuten: string;
}

export interface AppliableItem {
    classId: string;
    appliable: boolean;
}

export interface CategoryItem {
    categoryId: string;
    categoryName: string;
    subCategories: CategoryItem[];
}

export interface Aprovers {
    apply: AproverOptionsApply;
    cancel: AproverOptionsCancel;
}
export interface AproverOptionsApply {
    approverList1: AproverOptionItemApply[];
    approverList2: AproverOptionItemApply[];
}
export interface AproverOptionItemApply {
    id: string;
    name: string;
}
export interface AproverOptionsCancel {
    approverList1: AproverOptionItemCancel[];
    approverList2: AproverOptionItemCancel[];
}
export interface AproverOptionItemCancel {
    userId: string;
    approverOptionString: string;
}

export interface CareerHistories {
    onGoing: CareerHistoryItemOnGoing[];
    result: CareerHistoryItemResult[];
}
export interface CareerHistoryItemOnGoing {
    careerId: string;
    careerTitle: string;
    careerTypeId: string;
    compulsoryId: string;
    compulsoryName: string;
    classId: string;
    classroom: string;
    classStatus: string;
    classTitle: string;
    jissiKikan: string;
    jissiEndDateODT: string;
    jissiStartDateODT: string;
    imstatListStatusId: string;
    status: string;
    jukou: string;
    progress: string;
    enqueteDispFlg: boolean;
    taskReportOkFlg: boolean;
    testFlg: boolean;
    appCancelOkFlg: boolean;
    lecCancelOkFlg: boolean;
    appChangeOkFlg: boolean;
    appResultOkFlg: boolean;
    careerImageUrl: string;
    multiApplyFlag: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    outOfPeriodFlg: boolean;
    kadai: string;
    kadaiWithin: number;
    enquete: string;
    enqueteWithin: number;
    aplType: string;
}
export interface CareerHistoryItemResult {
    careerId: string;
    careerTitle: string;
    careerTypeId: string;
    compulsoryId: string;
    compulsoryName: string;
    classId: string;
    classTitle: string;
    jissiKikan: string;
    jissiEndDateODT: string;
    jissiStartDateODT: string;
    imstatListStatusId: string;
    status: string;
    jukou: string;
    seq: string;
    resultStatus: string;
    multiApplyFlag: string;
    enqueteDispFlg: boolean;
    taskReportOkFlg: boolean;
    testFlg: boolean;
    careerImageUrl: string;
    classroom: string;
    startDate: string;
    endDate: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    retakeOkFlg: boolean;
    outOfPeriodFlg: boolean;
    kadai: string;
    kadaiWithin: number;
    enquete: string;
    enqueteWithin: number;
}

/**
 * API[研修情報・受講履歴取得: /careerInfoStudentHistory]用のサービスクラス。
 */
class CareerInfoStudentHistoryService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "careerInfoStudentHistory");
    }

    /**
     * API[研修情報・受講履歴取得: /careerInfoStudentHistory]に対するFetch。
     *
     * @param payload {CareerInfoStudentHistoryPayload}
     * @returns {Promise<CareerInfoStudentHistoryResponse>} 応答データを返すPromise
     */
    public async fetch(payload: CareerInfoStudentHistoryPayload): Promise<CareerInfoStudentHistoryResponse> {
        return super.postWithPromise(payload).then((json: unknown) => json as CareerInfoStudentHistoryResponse);
    }
}

export default CareerInfoStudentHistoryService;
